import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from './AuthProvider';

export const ProtectedRoutes = ({ children }) => {
  const auth = useAuth();
  var authCheck = auth.getSessionData();
  if (!authCheck || authCheck?.length === 0 || authCheck === 'null') {
    // user is not authenticated
    return <Navigate to="/security/logout" />;
  }
  return children;
};
ProtectedRoutes.propTypes = {
  children: PropTypes.node
};
